import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

export default function ProtocolsChart() {
	const protocolsData = [
		{ name: "BACnet/IP", color: "#50cd89", dataPoints: [65, 58, 70, 68, 72, 75] },
		{ name: "Modbus-TCP", color: "#3b82f6", dataPoints: [34, 40, 35, 42, 38, 45] },
		{ name: "EtherNet/IP", color: "#f1bc00", dataPoints: [28, 35, 32, 38, 40, 42] },
		{ name: "S7COMM-PLUS", color: "#5d8c3e", dataPoints: [15, 18, 20, 22, 25, 28] },
		{ name: "UDP", color: "#b8860b", dataPoints: [22, 25, 20, 23, 28, 30] },
		{ name: "Others", color: "#9ca3af", dataPoints: [8, 10, 12, 15, 18, 20] },
	];

	const getChartOption = (data) => ({
		tooltip: {
			trigger: "axis",
			backgroundColor: "rgba(0, 0, 0, 0.8)",
			borderColor: "#60a5fa",
			textStyle: { color: "#fff", fontSize: 10 },
		},
		xAxis: {
			type: "category",
			show: false,
			boundaryGap: false,
		},
		yAxis: {
			type: "value",
			show: false,
		},
		series: [
			{
				data: data.dataPoints,
				type: "line",
				smooth: true,
				symbolSize: 0,
				itemStyle: { color: data.color },
				areaStyle: { color: data.color, opacity: 0.8 },
			},
		],
	});

	return (
		<div className="col-lg-4 mb-3">
			<div className="card bg-secondary h-100">
				<div className="card-body">
					<h5 className="text-white mb-6">Protocols (1 hr)</h5>
					<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
						{protocolsData.map((protocol, index) => (
							<div key={index}>
								<div style={{ marginBottom: "8px", fontSize: "11px" }}>
									<span style={{ color: protocol.color, fontWeight: "bold" }}>
										{protocol.name}
									</span>
								</div>
								<ReactECharts
									option={getChartOption(protocol)}
									style={{ height: 35 }}
									echarts={echarts}
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
